/* Minvelle Cart v2 */
(function () {
  'use strict';
  const FREE_SHIPPING_THRESHOLD_CENTS = 3000;
  const BELOW_THRESHOLD_RATE_CENTS = 499;
  const SUB_PLAN_ID = 692093845850;
  const VARIANT_1BOX = 53814535455066;
  const VARIANT_2BOX = 53814535487834;
  const VARIANT_6BOX = 53814535520602;

  const t = (k) => (window.MinvelleCartStrings || {})[k] || k;
  const fmtMoney = (c) => '€' + (c / 100).toFixed(2).replace('.', ',');

  const state = { cart: null, open: false };
  let elRoot, elBackdrop;

  // Device + browser detection for express-wallet filtering
  const _ua = navigator.userAgent;
  const _isIOS = /iPad|iPhone|iPod/.test(_ua) && !window.MSStream;
  const _isMac = /Macintosh/.test(_ua) && !_isIOS;
  const _isAndroid = /Android/.test(_ua);
  const _isSafari = /Safari/.test(_ua) && !/Chrome|Chromium|Edg/.test(_ua);
  const _isAppleDevice = _isIOS || _isMac;
  const _isChromeDesktop = /Chrome/.test(_ua) && !/Android|Mobile/.test(_ua);

  function filterWallets(){
    const root = document.querySelector('shopify-accelerated-checkout-cart');
    if (!root) return;
    const tagMap = [
      { match: 'apple-pay', key: 'apple' },
      { match: 'google-pay', key: 'google' },
      { match: 'paypal',    key: 'paypal' },
      { match: 'shop-pay',  key: 'shop'   }
    ];
    const hideKeys = new Set();
    if (_isIOS) {
      hideKeys.add('google'); hideKeys.add('paypal');
    } else if (_isAndroid) {
      hideKeys.add('apple'); hideKeys.add('paypal');
    } else if (_isMac && _isSafari) {
      hideKeys.add('google');
    } else if (_isChromeDesktop || (!_isAppleDevice && !_isAndroid)) {
      hideKeys.add('apple');
    }
    if (hideKeys.size === 0) return;
    const candidates = [];
    for (const c of Array.from(root.children)) {
      const tag = c.tagName.toLowerCase();
      const hit = tagMap.find((m) => tag.includes(m.match));
      if (!hit) continue;
      candidates.push({ el: c, key: hit.key });
    }
    // Safety net: never hide every wallet
    const remainingAfterHide = candidates.filter((c) => !hideKeys.has(c.key));
    if (candidates.length > 0 && remainingAfterHide.length === 0) return;
    for (const c of candidates) {
      if (hideKeys.has(c.key)) c.el.style.display = 'none';
    }
  }

  async function fetchCart(){const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});if(!r.ok)throw new Error('cart-fetch-failed');return r.json();}
  async function addItem(vId,qty,plan){const body={id:vId,quantity:qty||1};if(plan)body.selling_plan=plan;const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});if(!r.ok){const m=await r.text();throw new Error('add-failed:'+m.slice(0,200));}return r.json();}
  async function changeLine(key,upd){const body=Object.assign({id:key},upd);const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});if(!r.ok)throw new Error('change-failed');return r.json();}
  async function applyDiscount(code){
    const r=await fetch('/discount/'+encodeURIComponent(code),{redirect:'manual'});
    return r;
  }

  function open(){if(!elRoot)return;state.open=true;elRoot.setAttribute('open','');elBackdrop.setAttribute('open','');document.body.style.overflow='hidden';document.dispatchEvent(new CustomEvent('minvelle:cart:open'));ensureExpressCheckout();}

  let _expressLoaded = false;
  let _expressLoading = null;
  async function ensureExpressCheckout(){
    const wrap = elRoot && elRoot.querySelector('[data-express-wallets]');
    const label = elRoot && elRoot.querySelector('[data-express-label]');
    if (!wrap) return;
    if (_expressLoaded) return;
    if (_expressLoading) return _expressLoading;
    _expressLoading = (async () => {
      try {
        const r = await fetch('/cart', { credentials: 'same-origin' });
        if (!r.ok) throw new Error('cart-fetch-' + r.status);
        const html = await r.text();
        const m = html.match(/<shopify-accelerated-checkout-cart[^>]*>[\s\S]*?<\/shopify-accelerated-checkout-cart>/);
        if (!m) throw new Error('component-not-found');
        wrap.innerHTML = m[0];
        if (label) label.hidden = false;
        if (label) label.removeAttribute('hidden');
        await new Promise(res => setTimeout(res, 50));
        if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
          window.Shopify.PaymentButton.init();
        }
        _expressLoaded = true;
        setTimeout(filterWallets, 600);
        setTimeout(filterWallets, 1500);
      } catch (e) {
        console.warn('[MinvelleCart] express checkout load failed', e);
        if (label) label.hidden = true;
        wrap.innerHTML = '';
      } finally {
        _expressLoading = null;
      }
    })();
    return _expressLoading;
  }
  function close(){if(!elRoot)return;state.open=false;elRoot.removeAttribute('open');elBackdrop.removeAttribute('open');document.body.style.overflow='';document.dispatchEvent(new CustomEvent('minvelle:cart:close'));}
  function showToast(msg){const tt=elRoot.querySelector('.minvelle-cart__toast');if(!tt)return;tt.textContent=msg;tt.setAttribute('visible','');setTimeout(()=>tt.removeAttribute('visible'),4000);}

  async function refresh(){try{state.cart=await fetchCart();render();}catch(e){console.error('[MinvelleCart] refresh failed',e);showToast(t('cart.minvelle.error_refresh'));}}

  function deliveryRange() {
    const start = new Date();
    start.setDate(start.getDate() + 5);
    const end = new Date();
    end.setDate(end.getDate() + 9);
    const opts = { weekday: 'short', month: 'short', day: 'numeric' };
    const lang = (document.documentElement.lang || 'en').slice(0,2);
    const localeTag = lang === 'de' ? 'de-AT' : 'en-US';
    return t('cart.minvelle.delivery_html')
      .replace('{start}', start.toLocaleDateString(localeTag, opts))
      .replace('{end}', end.toLocaleDateString(localeTag, opts));
  }

  function render(){
    const body = elRoot.querySelector('[data-cart-body]');
    const footer = elRoot.querySelector('[data-cart-footer]');
    const stickyCta = elRoot.querySelector('[data-sticky-cta]');
    if (!state.cart) return;
    body.innerHTML = '';

    renderShippingBar(state.cart);

    if (!state.cart.items || state.cart.items.length === 0) {
      body.innerHTML = '<div class="minvelle-cart__empty">' +
        '<h3>' + t('cart.minvelle.empty_title') + '</h3>' +
        '<p>' + t('cart.minvelle.empty_body') + '</p>' +
        '<a class="button" href="/products/minvelle-viral-remineralizing-gum">' + t('cart.minvelle.empty_cta') + '</a>' +
      '</div>';
      footer.hidden = true;
      if (stickyCta) stickyCta.hidden = true;
      return;
    }
    footer.hidden = false;
    if (stickyCta) stickyCta.hidden = false;

    state.cart.items.forEach((item) => body.appendChild(renderLine(item)));

    const promos = elRoot.querySelector('[data-cart-promos]');
    if (promos) {
      promos.innerHTML = '';
      const subPanel = buildSubscriptionPanel(state.cart);
      if (subPanel) promos.appendChild(subPanel);
      const upsell = buildUpsell(state.cart);
      if (upsell) promos.appendChild(upsell);
    }

    const subtotal = state.cart.items_subtotal_price;
    const freeShipping = subtotal >= FREE_SHIPPING_THRESHOLD_CENTS;
    const shipping = freeShipping ? 0 : BELOW_THRESHOLD_RATE_CENTS;
    const total = subtotal + shipping;

    elRoot.querySelector('[data-checkout-total]').textContent = fmtMoney(total);

    const deliveryEl = elRoot.querySelector('[data-delivery-text]');
    if (deliveryEl) deliveryEl.innerHTML = deliveryRange();
  }

  function renderLine(item){
    const div=document.createElement('div');div.className='minvelle-cart__line';div.dataset.lineKey=item.key;
    const isSub=!!item.selling_plan_allocation;
    const img=item.image||(item.featured_image&&item.featured_image.url)||'';
    const compareCents=item.original_line_price && item.original_line_price>item.final_line_price ? item.original_line_price : null;
    div.innerHTML =
      '<img class="minvelle-cart__line-img" src="'+img+'" alt="'+(item.product_title||'')+'">'+
      '<div class="minvelle-cart__line-meta">'+
        '<span class="minvelle-cart__line-title">'+(item.product_title || '').replace(/Remineralizing\s*/i,'')+'</span>'+
        '<span class="minvelle-cart__line-variant">'+(item.variant_title||'')+'</span>'+
        (isSub?'<span class="minvelle-cart__line-sub-badge">🔁 '+t('cart.minvelle.sub_badge')+'</span>':'')+
        '<div class="minvelle-cart__line-qty">'+
          '<button type="button" data-qty-dec aria-label="'+t('cart.minvelle.qty_decrease')+'">−</button>'+
          '<span>'+item.quantity+'</span>'+
          '<button type="button" data-qty-inc aria-label="'+t('cart.minvelle.qty_increase')+'">+</button>'+
        '</div>'+
      '</div>'+
      '<div class="minvelle-cart__line-right">'+
        '<span class="minvelle-cart__line-price">'+fmtMoney(item.final_line_price)+'</span>'+
        (compareCents?'<span class="minvelle-cart__line-compare">'+fmtMoney(compareCents)+'</span>':'')+
        '<button type="button" data-line-remove>'+t('cart.minvelle.remove')+'</button>'+
      '</div>';
    div.querySelector('[data-qty-dec]').addEventListener('click',()=>updateQty(item.key,Math.max(0,item.quantity-1)));
    div.querySelector('[data-qty-inc]').addEventListener('click',()=>updateQty(item.key,item.quantity+1));
    div.querySelector('[data-line-remove]').addEventListener('click',()=>updateQty(item.key,0));
    return div;
  }

  async function updateQty(key,qty){try{state.cart=await changeLine(key,{quantity:qty});render();}catch(e){console.error('[MinvelleCart] updateQty failed',e);showToast(t('cart.minvelle.error_refresh'));}}

  function renderShippingBar(cart){
    const subtotal=cart.items_subtotal_price;
    const bar=elRoot.querySelector('[data-shipping-bar]');
    const fill=elRoot.querySelector('[data-shipping-fill]');
    const label=elRoot.querySelector('[data-shipping-label]');
    const amount=elRoot.querySelector('[data-shipping-amount]');
    if(subtotal>=FREE_SHIPPING_THRESHOLD_CENTS){
      bar.classList.add('minvelle-cart__shipping--unlocked');
      label.innerHTML='🎉 <strong>'+t('cart.minvelle.shipping_unlocked')+'</strong>';
      amount.textContent='';
      fill.style.width='100%';
    } else {
      bar.classList.remove('minvelle-cart__shipping--unlocked');
      const remaining = FREE_SHIPPING_THRESHOLD_CENTS - subtotal;
      label.innerHTML = t('cart.minvelle.shipping_progress_label_html')
        .replace('{current}', fmtMoney(subtotal))
        .replace('{target}', fmtMoney(FREE_SHIPPING_THRESHOLD_CENTS));
      amount.innerHTML = t('cart.minvelle.shipping_progress_remaining_html').replace('{amount}', fmtMoney(remaining));
      const pct = Math.min(100, Math.max(4, (subtotal / FREE_SHIPPING_THRESHOLD_CENTS) * 100));
      fill.style.width = pct + '%';
    }
  }

  function buildSubscriptionPanel(cart){
    if(!cart.items)return null;
    const c=cart.items.find(it=>it.variant_id===VARIANT_2BOX && !it.selling_plan_allocation);
    if(!c)return null;
    const div=document.createElement('div');div.className='minvelle-cart__sub-panel';
    div.innerHTML=
      '<div class="minvelle-cart__sub-panel-title">🔁 '+t('cart.minvelle.sub_panel_title')+'</div>'+
      '<div class="minvelle-cart__sub-panel-sub">'+t('cart.minvelle.sub_panel_sub_html')+'</div>'+
      '<button type="button" class="minvelle-cart__sub-panel-cta">'+t('cart.minvelle.sub_panel_cta')+'</button>'+
      '<button type="button" class="minvelle-cart__sub-panel-alt">'+t('cart.minvelle.sub_panel_alt')+'</button>';
    div.querySelector('.minvelle-cart__sub-panel-cta').addEventListener('click', async () => {
      try{state.cart=await changeLine(c.key,{selling_plan:SUB_PLAN_ID});render();}catch(e){showToast(t('cart.minvelle.error_refresh'));}
    });
    div.querySelector('.minvelle-cart__sub-panel-alt').addEventListener('click',()=>{div.style.display='none';});
    return div;
  }

  function buildUpsell(cart){
    if(!cart.items || cart.items.length !== 1) return null;
    const item = cart.items[0];
    const isSub = !!item.selling_plan_allocation;
    let title, sub, cta, action;
    if (item.variant_id === VARIANT_1BOX && !isSub) {
      title = t('cart.minvelle.upsell_1to2_title');
      sub = t('cart.minvelle.upsell_1to2_sub');
      cta = t('cart.minvelle.upsell_1to2_cta');
      action = async () => {
        try { await changeLine(item.key, {quantity: 0}); await addItem(VARIANT_2BOX, 1); await refresh(); }
        catch (e) { console.error('1to2 swap', e); showToast(t('cart.minvelle.error_refresh')); }
      };
    } else if (item.variant_id === VARIANT_2BOX && isSub) {
      title = t('cart.minvelle.upsell_2to6_title');
      sub = t('cart.minvelle.upsell_2to6_sub');
      cta = t('cart.minvelle.upsell_2to6_cta');
      action = async () => {
        try { await changeLine(item.key, {quantity: 0}); await addItem(VARIANT_6BOX, 1); await refresh(); }
        catch (e) { console.error('2to6 swap', e); showToast(t('cart.minvelle.error_refresh')); }
      };
    } else { return null; }
    const div=document.createElement('div');div.className='minvelle-cart__upsell';
    div.innerHTML='<div class="minvelle-cart__upsell-title">'+title+'</div><div class="minvelle-cart__upsell-sub">'+sub+'</div><button type="button" class="minvelle-cart__upsell-cta">'+cta+'</button>';
    div.querySelector('button').addEventListener('click', action);
    return div;
  }

  function bindDiscount(){
    const discountWrap = elRoot.querySelector('[data-discount]');
    const toggle = elRoot.querySelector('[data-discount-toggle]');
    const panel = elRoot.querySelector('[data-discount-panel]');
    const input = elRoot.querySelector('[data-discount-input]');
    const apply = elRoot.querySelector('[data-discount-apply]');
    const msg = elRoot.querySelector('[data-discount-msg]');
    if (!toggle) return;
    toggle.addEventListener('click', () => {
      const open = !panel.hidden;
      panel.hidden = open;
      if (open) discountWrap.removeAttribute('open');
      else { discountWrap.setAttribute('open',''); input.focus(); }
    });
    apply.addEventListener('click', async () => {
      const code = (input.value || '').trim();
      if (!code) return;
      try {
        await applyDiscount(code);
        msg.textContent = t('cart.minvelle.discount_applied_html').replace('{code}', code);
        msg.classList.remove('minvelle-cart__discount-msg--err');
        msg.classList.add('minvelle-cart__discount-msg--ok');
        msg.hidden = false;
      } catch (e) {
        msg.textContent = t('cart.minvelle.discount_invalid');
        msg.classList.remove('minvelle-cart__discount-msg--ok');
        msg.classList.add('minvelle-cart__discount-msg--err');
        msg.hidden = false;
      }
    });
  }

  function bindAddToCartHooks(){
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-add-to-cart]');
      if (btn) {
        e.preventDefault();
        const vId = parseInt(btn.dataset.variantId, 10);
        const qty = parseInt(btn.dataset.quantity || '1', 10);
        const plan = btn.dataset.sellingPlanId ? parseInt(btn.dataset.sellingPlanId, 10) : null;
        if (!vId) return;
        try { await addItem(vId, qty, plan); await refresh(); open(); }
        catch (err) { console.error(err); showToast(t('cart.minvelle.error_add')); }
        return;
      }
      const a = e.target.closest('a[href^="/cart/"]');
      if (a) {
        const m = a.getAttribute('href').match(/^\/cart\/(\d+):(\d+)/);
        if (m) {
          e.preventDefault();
          try { await addItem(parseInt(m[1],10), parseInt(m[2],10)); await refresh(); open(); }
          catch (err) { console.error(err); showToast(t('cart.minvelle.error_add')); }
        }
      }
    });
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      const fd = new FormData(form);
      try { const r = await fetch('/cart/add.js', { method: 'POST', body: fd }); if (!r.ok) throw new Error('add-form-failed'); await refresh(); open(); }
      catch (err) { console.error(err); showToast(t('cart.minvelle.error_add')); }
    });
  }

  function bindDrawerControls(){
    elRoot.querySelector('.minvelle-cart__close').addEventListener('click', close);
    elBackdrop.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && state.open) close(); });
    document.addEventListener('click', (e) => { const toggle = e.target.closest('[data-cart-toggle]'); if (toggle) { e.preventDefault(); refresh().then(open); } });
  }

  function bindCheckoutOnce(){const btn=elRoot.querySelector('[data-cart-checkout]');if(btn&&!btn._bound){btn._bound=true;btn.addEventListener('click',()=>{window.location.href='/checkout';});}}

  function boot(){
    elRoot = document.querySelector('.minvelle-cart');
    elBackdrop = document.querySelector('.minvelle-cart__backdrop');
    if (!elRoot || !elBackdrop) { console.warn('[MinvelleCart] drawer markup not found'); return; }
    bindDrawerControls();
    bindAddToCartHooks();
    bindDiscount();
    refresh().then(bindCheckoutOnce);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.MinvelleCart = { open, close, refresh, addItem, state, filterWallets };
})();
